// Accordion Tabs
// Switching Tabs and changes the content
document.querySelectorAll(".tab-title").forEach((head) => {
  let first = head.dataset.first;
  document.querySelectorAll(`.${first}`).forEach((ele) => ele.classList.add("active-tab-content"));
  head.addEventListener("click", (event) => {
    let tabId = head.dataset.tab;
    document.querySelectorAll(".tab-title").forEach((h) => h.classList.remove("active-tab"));
    document.querySelectorAll(".accordion-container").forEach((c) => c.classList.remove("active-tab-content"));
    head.classList.add("active-tab");
    document.querySelectorAll(`.${tabId}`).forEach((ele) => ele.classList.add("active-tab-content"));
  });
});

// Append the questions to the accordion
document.querySelectorAll(".question-answer__contianer").forEach((each) => {
  let dataChild = each.dataset.child;
  if (dataChild != "") {
    document
      .querySelectorAll(`.${dataChild}`)
      .forEach((ele) => each.appendChild(ele));
  }
});

// Toggle the overflow of accrodion
let overFlowBtn = document.getElementById("accordionOverflow");
let accordionContainer = document.getElementById("accordionContainer");
const firstAccordionOpen = accordionContainer.children[0].querySelector('.accordion-details');
const accordionQuestionCon = firstAccordionOpen.querySelector('.question-answer__contianer') 
const accordionQuestion = accordionQuestionCon.children[0]?.querySelector('.question')
firstAccordionOpen.setAttribute('open', true)
accordionQuestion?.setAttribute('open', true)
overFlowBtn?.addEventListener("click", () => {
  if (accordionContainer.classList.contains("overflow-visible")) {
    accordionContainer.classList.remove("overflow-visible");
    overFlowBtn.classList.remove("transform");
  } else {
    accordionContainer.classList.add("overflow-visible");
    overFlowBtn.classList.add("transform");
  }
});

// Accordion Search based on the title
let searchInput = document.getElementById("accordionSearch");
let noResults = document.getElementById("noResults");
var accordion_list = [];

searchInput?.addEventListener("keyup", function (event) {
  let searchQuery = event.target.value.toLowerCase();
  let accordion = document.querySelectorAll(".accordion-details .summary__text");

for (let i = 0; i < accordion.length; i++) {
  const currentName = accordion[i].textContent.toLowerCase();

  // Search and Display the content
  if (currentName.includes(searchQuery)) {
    accordion[i].closest('.accordion-details').style.display = "block";
  } else {
    accordion[i].closest('.accordion-details').style.display = "none";
  }

    // To Show the accordion no results found
    let obj = {};
    obj.accordion_title = currentName;
    accordion_list.push(obj);

    var filteredList = accordion_list.filter(function (arr) {
      return arr.accordion_title.includes(searchQuery);
    });

    if (filteredList.length === 0) {
      noResults.innerHTML = "No Results Found";
    } else {
      noResults.innerHTML = "";
    }
  }
});
